<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="update-plan-modal" tabindex="-1" role="dialog" aria-labelledby="movePlanModal">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> Move {{account.domain}} plan </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <p>Please enter email of the user below to whom you want to shift this plan.</p>

              </div>
            </div>
              <div class="row">
                <div class="col-md-12">
<!--                  <label>Enter Email</label>-->
                  <input type="text" required class="form-control h-43" placeholder="Enter Email" :disabled="loading" v-model="moveTo"/>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button @click="movePlan()" :disabled="loading" type="submit" class="btn btn-info btn-md d-inline pull-right">
                    <span v-if="loading">
                      <div class="loader" style="width: 15px;height: 15px; margin: 0.2rem 0 !important;"></div>
                    </span>
                    <span v-else>
                      Move Plan
                    </span>
                  </button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "movePlanModal",
  data(){
    return {
      loading: false,
      account: {},
      moveTo: ''
    }
  },
  computed: {
    customer () {
      return this.$store.getters["customer/details"];
    },
  },
  methods: {
    load (account) {
      this.loading = false
      console.log(
         this.customer
      )
      $('#update-plan-modal').modal('show');
      this.account = account;

    },
    async removeDomainsFromCollaboratorAndSupervisor(planToMove){
      let userRef= await db.collection('users').doc(this.customer.docID).get()
      let userInfo=userRef.data()
      let domains=[]
      domains.push(planToMove.primary.domain)
      if(planToMove.addon.length >0) {
        planToMove.addon.map(el => {
          domains.push(el.domain)
        })
      }
      if(userInfo.collaborators && userInfo.collaborators.length>0){
        for(const row of userInfo.collaborators){
          console.log('row', row.uid)
          // delete domains from supervisor array
          if(row.uid){
            row.domains=row.domains.filter(el => domains.includes(el))
            let collaboratorRef=await db.collection('users').doc(row.uid).get()
            const collaborator=collaboratorRef.data()
            console.log(collaboratorRef)
            if(collaboratorRef.exists){
              for(const row1 of collaborator.supervisors){
                if(row1.supervisorId===this.customer.docID){
                  row1.allowedDomains=row1.allowedDomains.filter(el => domains.includes(el))
                }
              }
              await db.collection('users').doc(collaboratorRef.id).update({supervisors: collaborator.supervisors})
            }
          }
        }
        await db.collection('users').doc(this.customer.docID).update({collaborators: userInfo.collaborators})
      }
    },
    async movePlan() {
      try{
        if (!this.moveTo) {
          return
        }
        swal({
          title: "Are you sure?",
          text: 'Please confirm that you want to move this plan.',
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
          .then( async result => {
            if(result.value){
              console.log(this.moveTo)
              this.loading=true
              if(this.moveTo===this.customer.email){
                this.moveTo=''
                this.loading=false
                $('#update-plan-modal').modal('hide');
                swal('Error!', 'You can not enter same user\'s email to move plan!', 'error');
                return

              }
              const account2User=await db.collection('users').where('email', '==', this.moveTo).get();
              let secondUser={}
              if(account2User.size>0){
                account2User.forEach(el => {
                  secondUser= {id: el.id,...el.data()}
                })
                console.log('data',secondUser);
                const accRef = await db.collection('hostingAccounts').doc(this.customer.docID).get();
                const accounts1 = accRef.data().accounts || [];
                const beforePayload = JSON.parse(JSON.stringify(accounts1))
                const accRef2 = await db.collection('hostingAccounts').doc(secondUser.id).get();
                const accounts2 = accRef2.data().accounts || [];
                const beforePayload1 = JSON.parse(JSON.stringify(accounts1))
                const planToMove = accounts1[this.account.planIndex];
                accounts2.push(planToMove);
                accounts1.splice(this.account.planIndex, 1);
                console.log(accounts1)
                console.log(accounts2)
                await this.addHostingAccountEventLog({hostingAccountId : this.customer.docID ,  afterPayload: accounts1 , beforePayload: beforePayload ,action: 'Move Plan'})
                await db.collection('hostingAccounts').doc(this.customer.docID).update({
                  accounts: accounts1
                })
                await this.addHostingAccountEventLog({hostingAccountId : secondUser.id ,  afterPayload: accounts2 , beforePayload: beforePayload1,action: 'Move Plan'})
                await db.collection('hostingAccounts').doc(secondUser.id).update({
                  accounts: accounts2
                })
                // delete the domains associated to previous user collaborators
                try{
                  await this.removeDomainsFromCollaboratorAndSupervisor(planToMove)
                }catch(e){
                  console.log('Something went wrong while deleting domains'+ e.toString())
                }
                this.loading=false;
                this.moveTo=''
                $('#update-plan-modal').modal('hide');
                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: 'Plan has been moved successfully!',
                  level: 'info'
                })
                swal('Success!', 'Plan has been moved successfully!', 'success');
              }
              else{
                this.moveTo=''
                this.loading=false
                $('#update-plan-modal').modal('hide');
                this.addLog({
                  message: 'No user found against that email!',
                  level: 'danger'
                })
                swal('Error!', 'No user found against that email!', 'error');
              }
            }
          })
      }
      catch (err) {
        this.moveTo=''
        this.loading=false
        $('#update-plan-modal').modal('hide');
        this.addLog({
          message: 'Something went wrong while moving plan!',
          level: 'danger'
        })
        swal('Error!', 'Something went wrong while moving plan!', 'error');

      }


    }
  }
}
</script>

<style scoped>

</style>
